import type { UIStringsOverride } from "../i18n-ui.ts";

/** Serbian (sr) UI strings. */
export const sr: UIStringsOverride = {
  actions: {
    addToCursor: "Додај у Cursor",
    addToVscode: "Додај у VS Code",
    askAI: "Питајте AI о овој страници",
    connectMcp: "Повежи се са MCP-ом",
    copied: "Копирано!",
    copyClaudeCode: "Копирај Claude Code команду",
    copyCode: "Копирај код",
    copyCodex: "Копирај Codex команду",
    copyMarkdown: "Копирај као Markdown",
    copyServerUrl: "Копирај URL сервера",
    edit: "Уреди на GitHub-у",
    export: "Извези",
    exportEpub: "Извези у EPUB",
    exportPdf: "Извези у PDF",
    generating: "Генерисање…",
    openIn: "Отвори у {name}",
    openInChat: "Отвори у ћаскању",
    scrollToTop: "Назад на врх",
  },
  ask: {
    ai: "AI",
    clear: "Обриши разговор",
    close: "Затвори",
    copy: "Копирај разговор",
    empty: "Поставите питање о документацији.",
    error: "Жао нам је, нешто је пошло наопако.",
    label: "Постави питање",
    placeholder: "Поставите питање…",
    send: "Пошаљи",
    tip: "Савет: Ћаскање можете отворити и затворити помоћу",
    title: "Питајте AI",
    you: "Ви",
  },
  banner: { dismiss: "Затвори обавештење" },
  changelog: {
    description: "Ажурирања производа и белешке о издањима.",
    showReleases: "Прикажи издања {version}",
    title: "Дневник измена",
  },
  content: { diagramError: "Није могуће приказати овај дијаграм." },
  feedback: {
    no: "Не",
    question: "Да ли вам је ова страница помогла?",
    thanks: "Хвала на вашој повратној информацији!",
    yes: "Да",
  },
  languageSwitcher: { label: "Језик", untranslated: "Није преведено" },
  nav: {
    back: "Назад",
    breadcrumb: "Путања навигације",
    closeNavigation: "Затвори навигацију",
    deprecated: "застарело",
    featured: "Истакнуто",
    githubRepository: "GitHub репозиторијум",
    navigation: "Навигација",
    primary: "Главна",
    sections: "Одељци",
    toggleNavigation: "Отвори или затвори навигацију",
    toggleTheme: "Промени тему боја",
  },
  notFound: {
    description: "Нисмо могли да пронађемо страницу коју тражите.",
    home: "Назад на почетну",
    title: "Страница није пронађена",
  },
  page: {
    lastUpdated: "Последње ажурирање",
    next: "Следеће",
    pagination: "Пагинација",
    previous: "Претходно",
    skipToContent: "Пређи на садржај",
  },
  search: {
    all: "Све",
    allLanguages: "Сви језици",
    askAi: "Питајте AI",
    askAiHint: "Добијте тренутан одговор од AI-ја",
    button: "Претражи",
    devOnly: "Претрага је доступна у продукцијској верзији.",
    error: "Нешто је пошло наопако. Покушајте поново.",
    label: "Претражи документацију",
    navigate: "навигација",
    noResults: "Нема резултата.",
    open: "отвори",
    placeholder: "Претражи документацију…",
    popular: "Популарно",
    preview: "преглед",
    results: "Резултати",
  },
  toc: { title: "На овој страници" },
};
